import React from 'react';
import { useTranslation } from 'react-i18next';
import { TabHeader } from '../../Common/TabHeader';

const CustomerDetailsActivity = () => {
  const { t } = useTranslation();

  return <TabHeader text={t('customers.tabs.activity')}></TabHeader>;
};
export default CustomerDetailsActivity;
